// This file exports customized blocks for Google Blockly labs.

import {blocks as spritelabBlocks} from './spritelabBlocks';

export default {
  ...spritelabBlocks,
};
